import CircleQuestionMarkOutlined from './src/circle-question-mark-outlined';
export default CircleQuestionMarkOutlined;